'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _auth = require('./auth.service');

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authModule = _angular2.default.module('auth.service', []).service('Auth', _auth2.default).name;

exports.default = authModule;


// WEBPACK FOOTER //
// ./client/app/services/authService/auth.js